module.exports = __webpack_public_path__ + "img/200.05a4e0fb.png";